import { Card, CardContent } from '@/components/ui/card'
import { TableCell, TableRow } from '@/components/ui/table'

export function PulsatingDot() {
  return (
    <div className="relative">
      <div className="absolute -inset-1 bg-blue-40/30 rounded-full animate-ping" />
      <div className="relative w-2 h-2 bg-blue-40 rounded-full" />
    </div>
  )
}

export function SalaryRowHint({ children }: { children?: React.ReactNode }) {
  return (
    <TableRow className="bg-blue-50/5">
      <TableCell
        colSpan={8}
        className="text-center py-4 text-sm border-t border-b border-blue-70"
      >
        <div className="flex items-center justify-center">
          <PulsatingDot />
          {children ? (
            children
          ) : (
            <>
              <span className="text-copy-primary font-medium ml-4">
                Want to see more details?
              </span>{' '}
              <span className="text-copy-primary ml-2">
                Click on any row to see more info
              </span>
            </>
          )}
        </div>
      </TableCell>
    </TableRow>
  )
}

export function SalaryRowHintMobile() {
  return (
    <Card className="rounded-none border-x-0 bg-blue-50/5 border-t border-b border-blue-70">
      <CardContent className="px-4 py-3 text-sm flex items-center">
        <PulsatingDot />
        <div className="ml-4">
          <p className="text-copy-primary font-medium">
            Want to see more details?
          </p>
          <p className="text-copy-primary">Tap on any row to see more info</p>
        </div>
      </CardContent>
    </Card>
  )
}
